import { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import "./Form.css";
import "react-phone-number-input/style.css";
// import Logo from "./assets/logo.svg";
import Select from "../Select/Select";
import { /* COURSE_TIMES, */ FORM_STATE } from "./Form.constants";
import DaySelect from "../DaySelect/DaySelect";
import { CommonContext } from "../../context";
import get from "lodash.get";
import { REQUEST_STATUS } from "../../hooks/useRequest/useRequest.constants";
import { FormResponseStyle } from "./Form.style";
import toast, { Toaster } from "react-hot-toast";
// @ts-ignore
import PhoneInput from "react-phone-number-input";
import ChangeLanguage from "../ChangeLanguage/ChangeLanguage";
import { useTranslation } from "react-i18next";
import CustomInput from "../input/input";
import { Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import ControlSwitch from "../controlSwitch";
import FormSelect from "../formSelect";
import { fetchAndDownloadData } from "../../services/downloadFile";

const Form = () => {
  const [state, setState] = useState<any>(FORM_STATE);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedCourseDay, setSelectedCourseDay] = useState<any | null>(null);
  const [otherDaysTitle, setOtherDaysTitle] = useState<string>("");
  const [otherDays, setOtherDays] = useState<boolean>(false);
  const [phoneError, setPhoneError] = useState<boolean>(false);
  const [courseDays, setCourseDays] = useState<any[]>([]);
  const [defaultOtherDays, setDefaultOtherDays] = useState<number[]>([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [customFields, setCustomFields] = useState<Record<string, any>>([]);
  const params = Object.fromEntries(searchParams.entries());
  const [show, setShow] = useState("form");
  const { t, i18n } = useTranslation();

  const {
    control,
    formState: { errors },
    register,
    getValues,
  } = useForm();

  const {
    state: {
      getDetailsState: { getDetailsData, getDetailsStatus },
      getBranchesState: { getBranchesData, getBranchesStatus },
      getCoursesState: { getCoursesData, getCoursesStatus },
      getCourseDaysState: { getCourseDaysData, getCourseDaysStatus },
      createOrderState: { createOrderData, createOrderStatus },
      getCourseShiftsState: { getCourseShiftsData, getCourseShiftsStatus },
    },
    actions: {
      getDetails,
      getBranches,
      getCourses,
      getCourseDays,
      createOrder,
      getCourseShifts,
    },
  } = useContext(CommonContext);

  const getParamsUrl = (params: any) => {
    const keys = Object.keys(params);
    const values = Object.values(params);
    let paramsUrl = "";
    for (let i = 0; i < keys.length; i++) {
      let param = `${keys[i]}=${values[i]}`;
      paramsUrl = paramsUrl.concat("&", param);
    }
    return paramsUrl.substring(1);
  };

  useEffect(() => {
    getDetails(getParamsUrl(params));
    getBranches();
    getCourses();
  }, []);

  console.log(get(getDetailsData, "data.settings.language", ""));

  useEffect(() => {
    if (getDetailsStatus === REQUEST_STATUS.success) {
      setCustomFields(get(getDetailsData, "data.settings.customFields", []));
      const lang = get(getDetailsData, "data.settings.language", "");
      if (lang && lang !== "uz") {
        if (lang === "kaa") {
          i18n.changeLanguage("kk");
        } else {
          i18n.changeLanguage(lang);
        }
      } else {
        i18n.changeLanguage(lang || "uz");
      }
      setState((prev: any) => ({
        ...prev,
        branch: {
          ...state.branch,
          value: get(getDetailsData, "data.branch.name"),
          id: get(getDetailsData, "data.branch._id"),
        },
        course: {
          ...state.course,
          value: get(getDetailsData, "data.course.name"),
          id: get(getDetailsData, "data.course._id"),
        },
      }));
    }
  }, [getDetailsStatus]);

  const handleChange = (e: any) => {
    const elementName = e.target.name;
    setState((prev: any) => ({
      ...prev,
      [elementName]: { ...state[elementName], value: e.target.value },
    }));
    if (elementName === "phoneNumber") {
      setPhoneError(false);
    }
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const customFieldValues: any = [];

    customFields.forEach((item: any) => {
      switch (item.type) {
        case "numeric":
        case "text":
          return (
            get(getValues(), get(item, `_id`)) &&
            customFieldValues.push({
              _id: get(item, "_id"),
              value: get(getValues(), get(item, `_id`)),
            })
          );
        case "date":
          return (
            get(getValues(), get(item, `_id`)) &&
            customFieldValues.push({
              _id: get(item, "_id"),
              value: new Date(get(getValues(), get(item, `_id`))).toISOString(),
            })
          );
        case "dateTime":
          return (
            get(getValues(), get(item, `_id`)) &&
            customFieldValues.push({
              _id: get(item, "_id"),
              value: new Date(get(getValues(), get(item, `_id`))).toISOString(),
            })
          );

        // case "file":
        //   return (
        //     checkImageUrl &&
        //     customFields.push({
        //       _id: get(item, "_id"),
        //       value: checkImageUrl,
        //     })
        //   );

        case "select":
          return (
            get(getValues(), get(item, `_id`))?.value &&
            customFieldValues.push({
              _id: get(item, "_id"),
              value: get(getValues(), get(item, `_id`))?.value,
            })
          );
        case "multiSelect":
          let multiS = get(getValues(), get(item, `_id`));
          multiS?.forEach(
            (multiItem: any) =>
              multiS?.length &&
              customFieldValues.push({
                _id: get(item, "_id"),
                value: get(multiItem, `value`),
              })
          );
          return customFields;
        case "toogleSwitch":
          return customFieldValues.push({
            _id: get(item, "_id"),
            value: get(getValues(), get(item, `_id`)),
          });
        default:
          return [...customFieldValues];
      }
    });

    const validPhoneNumber = state.phoneNumber.value.length === 13;

    if (!validPhoneNumber) {
      setPhoneError(true);
    }

    const keys = Object.keys(state);
    keys.map((key) => {
      if (!state[key].value && state[key].required) {
        setState((prev: any) => ({
          ...prev,
          [key]: { ...state[key], error: "empty" },
        }));
      }
    });

    const requestData = {
      customFields: [...customFieldValues],
      surveyId: get(getDetailsData, "data.surveyId"),
      firstName: state.name.value,
      lastName: state.surname.value,
      phoneNumber: state.phoneNumber.value,
      branchId:
        get(getBranchesData, "data", []).length > 1
          ? state.branch.id
          : get(getBranchesData, "data")[0]._id,
      courseId: state.course.id ? state.course.id : null,
      courseDay: selectedCourseDay
        ? {
            ...selectedCourseDay,
            title: selectedCourseDay.title ? selectedCourseDay.title : null,
          }
        : null,
      courseShift: state.courseTime
        ? {
            startHour: state.courseTime.value.split("-")[0]?.replace(" ", ""),
            endHour: state.courseTime.value.split("-")[1]?.replace(" ", ""),
          }
        : null,
      comment: state.comment.value,
    };

    if (validPhoneNumber && state.phoneNumber.value && state.name.value) {
      await createOrder(requestData);
    }
  };

  useEffect(() => {
    if (createOrderStatus === REQUEST_STATUS.success) {
      setShow("formResponse");
    }
    if (createOrderStatus === REQUEST_STATUS.failed) {
      toast.error("Ma'lumotlarni to'g'ri kiriting");
    }
  }, [createOrderStatus]);

  return (
    <>
      {show === "form" && (
        <div className="wrapper">
          <div className="language">
            <ChangeLanguage />
          </div>
          <form className="form" onSubmit={handleSubmit}>
            <div className="logo">
              {get(getDetailsData, "data.settings.logo") && (
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    get(getDetailsData, "data.settings.logo")
                  }
                  alt="logo"
                />
              )}
              <h3 className="lc-title">
                {get(getDetailsData, "data.settings.title")}
              </h3>
              <h3 className="lc-writing">
                {get(getDetailsData, "data.settings.subTitle", "")}
              </h3>
            </div>
            {/* <h2 className="title">Ro‘yxatdan o‘tish</h2> */}
            <div className="input-item">
              {/* <label htmlFor="name">Ism</label> */}
              <input
                type="text"
                className={`input ${
                  state.name.error && !state.name.value && "error"
                }`}
                name="name"
                placeholder={t("form.firstname")}
                onChange={handleChange}
              />
              {state.name.error && !state.name.value && (
                <span>{t("form.required")}</span>
              )}
            </div>
            {get(getDetailsData, "data.settings.fields.lastName") && (
              <div className="input-item">
                {/* <label htmlFor="name">Familiya</label> */}
                <input
                  type="text"
                  className={`input ${
                    state.surname.error && !state.surname.value && "error"
                  }`}
                  name="surname"
                  placeholder={t("form.lastname")}
                  onChange={handleChange}
                />
                {state.surname.error && !state.surname.value && (
                  <span>{t("form.required")}</span>
                )}
              </div>
            )}
            <div className="input-item">
              {/* <input
                type="number"
                className={`input ${
                  state.phoneNumber.error && !state.phoneNumber.value && "error"
                }`}
                name="phoneNumber"
                placeholder="Telefon raqamingizni kiriting"
                onChange={handleChange}
              /> */}
              <PhoneInput
                className={`input ${phoneError && "phoneError"}`}
                defaultCountry="UZ"
                value={state.phoneNumber.value}
                onChange={(value: any) => {
                  setPhoneError(false);
                  setState((prev: any) => ({
                    ...prev,
                    phoneNumber: { ...state.phoneNumber, value: value },
                  }));
                }}
              />
              {((!state.phoneNumber.value && state.phoneNumber.error) ||
                phoneError) && <span>{t("form.required")}</span>}
            </div>
            {get(getDetailsData, "data.settings.fields.branchId") &&
              get(getBranchesData, "data", []).length > 1 && (
                <div className="select-item">
                  <Select
                    name="branch"
                    state={state}
                    setState={setState}
                    options={get(getBranchesData, "data")}
                    placeholder={t("form.branch")}
                    value={state.branch.value}
                    onChange={(option: any) =>
                      getCourses({
                        branchId:
                          get(getBranchesData, "data", []).length > 1
                            ? option._id
                            : get(getBranchesData, "data")[0]._id,
                      })
                    }
                  />
                </div>
              )}
            {get(getDetailsData, "data.settings.fields.courseId") && (
              <div className="select-item">
                <Select
                  name="course"
                  state={state}
                  setState={setState}
                  options={get(getCoursesData, "data")}
                  placeholder={t("form.selectCourse")}
                  value={state.course.value}
                  onChange={(option: any) => {
                    getCourseDays({
                      branchId:
                        get(getBranchesData, "data", []).length > 1
                          ? state.branch.id
                          : get(getBranchesData, "data")[0]._id,
                    });
                    getCourseShifts({
                      branchId:
                        get(getBranchesData, "data", []).length > 1
                          ? state.branch.id
                          : get(getBranchesData, "data")[0]._id,
                      courseId: option._id,
                    });
                  }}
                />
              </div>
            )}
            {get(getDetailsData, "data.settings.fields.courseDay") && (
              <div className="select-item">
                <DaySelect
                  defaultOtherDays={defaultOtherDays}
                  courseDays={courseDays}
                  // label="Dars kunini tanlang"
                  selectedCourseDay={selectedCourseDay}
                  setSelectedCourseDay={setSelectedCourseDay}
                  otherDaysTitle={otherDaysTitle}
                  setOtherDaysTitle={setOtherDaysTitle}
                  otherDays={otherDays}
                  setOtherDays={setOtherDays}
                />
              </div>
            )}
            {get(getDetailsData, "data.settings.fields.courseShift") && (
              <div className="select-item">
                <Select
                  name="courseTime"
                  state={state}
                  setState={setState}
                  options={get(getCourseShiftsData, "data", []).map(
                    (time: any) => ({
                      name: `${time.startHour} - ${time.endHour}`,
                    })
                  )}
                  placeholder={t("form.selectTime")}
                  value={state.courseTime.value}
                />
              </div>
            )}
            {customFields.map((custom: any, index: number) => {
              switch (custom.type) {
                case "text":
                case "numeric":
                case "date":
                case "dateTime":
                  return (
                    <Grid item md={12} key={index}>
                      <CustomInput
                        label={custom.name}
                        error={errors[custom._id]}
                        params={{
                          ...register(custom._id, {
                            required: custom.required,
                          }),
                          type:
                            custom.type === "text"
                              ? "text"
                              : custom.type === "numeric"
                              ? "number"
                              : custom.type === "date"
                              ? "date"
                              : "datetime-local",
                          placeholder: "",
                        }}
                        className="mb-3"
                      />
                    </Grid>
                  );

                case "toogleSwitch":
                  return (
                    <Grid item md={4} key={index}>
                      <div className="mb-3">
                        <ControlSwitch
                          control={control}
                          name={custom._id}
                          label={custom.name}
                        />
                      </div>
                    </Grid>
                  );
                case "select":
                case "multiSelect":
                  return (
                    <Grid item md={4} key={index}>
                      <FormSelect
                        control={control}
                        name={custom._id}
                        label={custom.name}
                        isMulti={custom.type === "multiSelect" ? true : false}
                        getOptionLabel={(option) => get(option, "value", "")}
                        options={custom.options}
                        rules={{ required: custom.required }}
                        error={!!errors[custom._id]}
                        className="mb-3"
                      />
                    </Grid>
                  );
              }
            })}
            {get(getDetailsData, "data.settings.fields.comment") && (
              <div className="textarea-wrapper">
                <textarea
                  className="textarea"
                  placeholder={t("form.comment")}
                  name="comment"
                  onChange={handleChange}
                ></textarea>
              </div>
            )}
            {get(getDetailsData, "data.offerUrl", undefined) && (
              <button
                className="donwoladFile"
                type="button"
                onClick={() =>
                  fetchAndDownloadData(
                    get(getDetailsData, "data.offerUrl", ""),
                    "offerta"
                  )
                }
              >
                {t("form.downloadOfferta")}
              </button>
            )}

            <div className="btn-wrapper">
              <button className="btn">{t("form.send")}</button>
            </div>
          </form>
        </div>
      )}
      {show === "formResponse" && (
        <FormResponseStyle>
          <div className="content">
            <h2>{t("form.success")}</h2>
            <button
              className="another-btn"
              onClick={() => {
                setShow("form");
                setState(FORM_STATE);
                setSelectedCourseDay("");
              }}
            >
              {t("form.anotherQuestionnaire")}
            </button>
          </div>
        </FormResponseStyle>
      )}
      <Toaster />
    </>
  );
};

export default Form;
